import { Badge } from '@teach/ui'
import { categoryText } from '@/features/moderation/lib/reviewText'
import { parseViolationRef } from '@/features/moderation/lib/violationRef'
import { ViolationThumb } from '@/features/moderation/ViolationThumb'
import type { Violation } from '@/features/moderation/types'
import { articleViolationLabel } from '@/features/instructions/lib/articleViolationLabel'

const Row = ({ violation }: { violation: Violation }) => {
  const target = parseViolationRef(violation.ref)
  return (
    <div className="flex w-full items-start gap-3 rounded-md border p-3 text-left">
      {target.kind === 'image' ? <ViolationThumb url={target.url} /> : null}
      <div className="min-w-0 flex-1 space-y-1">
        <p className="text-sm font-medium break-words">
          {articleViolationLabel(target, violation.ref)}
        </p>
        <Badge variant="destructive">{categoryText(violation.category)}</Badge>
        <p className="text-sm text-muted-foreground break-words">{violation.reason}</p>
      </div>
    </div>
  )
}

/** Нарушения отклонённой заявки статьи. Перехода к месту нет: форма статьи — одна страница. */
export const ArticleViolationList = ({ violations }: { violations: Violation[] }) =>
  violations.length > 0 ? (
    <ul className="max-h-[40vh] space-y-2 overflow-y-auto">
      {violations.map((v, i) => (
        <li key={`${i}:${v.ref}:${v.category}`}>
          <Row violation={v} />
        </li>
      ))}
    </ul>
  ) : null
